<template>
  <v-dialog v-model="internalDialog" max-width="600px">
    <v-card>
      <v-col cols="12">
        <v-row>
          <v-col cols="6">
            <v-card-title>{{ dialogTitle }}</v-card-title>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn-toggle
              v-model="type"
              small
              class="my-0"
              tile
              color="primary"
              group
              @change="changeType"
            >
              <v-btn small value="fisica">P.Fisica</v-btn>
              <v-btn small value="juridica">P.Juridica</v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </v-col>
      <v-card-text>
        <v-form ref="form">
          <v-row v-if="type === 'fisica'">
            <v-col cols="8">
              <v-text-field
                v-model="localClient.dni"
                label="DNI"
                outlined
                dense
                required
                maxlength="8"
              />
            </v-col>
            <v-col cols="4">
              <v-btn-toggle
                v-model="localClient.sexo"
                small
                class="my-0"
                tile
                color="primary"
                group
                @change="generateCuit"
              >
                <v-btn small value="M">M</v-btn>
                <v-btn small value="F">F</v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-text-field
            v-model="localClient.cuit"
            :label="type === 'fisica' ? 'CUIT' : 'CUIL'"
            outlined
            dense
            required
            @input="onCuitInput"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            maxlength="13"
          />
          <v-select
            v-if="type === 'juridica'"
            v-model="localClient.tax_condition"
            :items="['ri', 'exento', 'monotributo']"
            label="Condición Fiscal"
            outlined
            dense
            required
          />
          <v-text-field
            v-model="localClient.first_name"
            :label="type === 'fisica' ? 'Nombre' : 'Razón Social'"
            outlined
            dense
            required
          />
          <v-text-field
            v-if="type === 'fisica'"
            v-model="localClient.last_name"
            label="Apellido"
            outlined
            dense
            required
          />
          <v-text-field
            v-model="localClient.email"
            label="Correo Electrónico"
            outlined
            dense
            required
          />
          <v-text-field
            v-model="localClient.phone"
            label="Teléfono"
            outlined
            dense
          />
          <v-text-field
            v-model="localClient.address"
            label="Dirección"
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn :disabled="!localClient.cuit || !localClient.first_name || (type === 'fisica' && !localClient.last_name) || (type === 'juridica' && !localClient.tax_condition)" color="primary" @click="submit">Guardar</v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay" :z-index="3000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import axios from "@/plugins/axios.js";

export default {
  name: "client-dialog",
  props: {
    dialog: Boolean,
    value: Boolean,
    action: {
      type: String,
      default: "add",
    },
    client: Object,
  },
  data() {
    return {
      formattedCuit: "",
      internalDialog: false,
      overlay: false,
      dialogTitle: this.action === "edit" ? "Editar Cliente" : "Nuevo Cliente",
      type: "fisica",
      localClient: this.client ? { ...this.client } : this.getEmptyClient(),
    };
  },
  watch: {
    client: {
      handler(newClient) {
        this.localClient = newClient ? { ...newClient } : this.getEmptyClient();
        this.type =
          newClient && newClient.tax_condition ? "juridica" : "fisica";
      },
      immediate: true,
      deep: true,
    },
    action: {
      handler(newAction) {
        this.dialogTitle =
          newAction === "edit" ? "Editar Cliente" : "Nuevo Cliente";
      },
      immediate: true,
    },
    value(val) {
      this.internalDialog = val;
    },
    internalDialog(val) {
      this.$emit("input", val); // sync con v-model
    },
  },
  methods: {
    onCuitInput(rawValue) {
      // Eliminar todo lo que no sea número
      const digits = rawValue.replace(/\D/g, "").slice(0, 11);
      let formatted = "";
      if (digits.length <= 2) {
        formatted = digits;
      } else if (digits.length <= 10) {
        formatted = `${digits.slice(0, 2)}-${digits.slice(2, 10)}`;
      } else {
        formatted = `${digits.slice(0, 2)}-${digits.slice(
          2,
          10
        )}-${digits.slice(10)}`;
      }
      //this.formattedCuit = formatted;
      this.localClient.cuit = formatted;
    },
    close() {
      this.internalDialog = false;
    },
    submit() {
      //validaciones
      /*if(this.type === "juridica" && !this.localClient.tax_condition) {
        this.$refs.form.validate();
      }*/
      //
      if (this.action === "add") {
        this.createClient();
      } else {
        this.updateClient();
      }
    },
    createClient() {
      this.overlay = true;
      //quitamos los guiones del CUIT
      this.localClient.cuit = this.localClient.cuit.replace(/-/g, "");
      axios
        .post("/clients/register", this.localClient)
        .then((resp) => {
          this.overlay = false;
          this.$emit("save-client", resp.data);
          this.clearForm();
          this.close();
        })
        .catch(() => {
          this.overlay = false;
          this.close();
        });
    },
    updateClient() {
      this.overlay = true;
      axios
        .put("/clients/update", this.localClient)
        .then((resp) => {
          this.overlay = false;
          this.$emit("update-client", resp.data);
          this.clearForm();
          this.close();
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    changeType() {
      this.localClient.tax_condition = null;
    },
    generateCuit() {
      const { dni, sexo } = this.localClient;
      if (dni && sexo) {
        this.localClient.cuit = this.calcularCuit(dni, sexo);
      } else {
        this.localClient.cuit = "";
      }
    },
    calcularCuit(dni, genero = "M") {
      const generarCuit = (prefijo, dni) => {
        const pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
        const numero = (prefijo + dni.toString().padStart(8, "0")).split("");
        const suma = numero.reduce(
          (acc, digit, idx) => acc + parseInt(digit) * pesos[idx],
          0
        );
        let resto = suma % 11;
        let verificador = 11 - resto;
        if (verificador === 11) verificador = 0;
        else if (verificador === 10) return null;
        return `${prefijo}-${dni.toString().padStart(8, "0")}-${verificador}`;
      };
      const prefijoInicial = genero === "F" ? "27" : "20";
      let cuit = generarCuit(prefijoInicial, dni);
      if (!cuit) cuit = generarCuit("23", dni);
      return cuit;
    },
    getEmptyClient() {
      return {
        id: null,
        cuit: "",
        first_name: "",
        dni: "",
        last_name: "",
        email: "",
        phone: "",
        address: "",
        sexo: "",
        tax_condition: "RI",
      };
    },
    clearForm() {
      this.localClient = this.getEmptyClient();
      this.type = "fisica";
    },
  },
};
</script>
<style scoped>
.v-btn-toggle {
  background-color: #f5f5f5;
  border-radius: 8px;
}
.v-btn-toggle .v-btn {
  min-width: 48px;
  padding: 0;
}
</style>